const breakpointClassPrefix = {
    tablet: "md",
    mobile: "xs",
};

const propClassValue = {
    backgroundImageSize: {
        auto: "bg-auto",
        contain: "bg-contain",
        cover: "bg-cover",
    },
    backgroundImagePosition: {
        bottom: "bg-bottom",
        center: "bg-center",
        left: "bg-left",
        "bottom left": "bg-left-bottom",
        "top left": "bg-left-top",
        right: "bg-right",
        "bottom right": "bg-right-bottom",
        "top right": "bg-right-top",
        top: "bg-top",
    },
    backgroundImageRepeat: {
        "no-repeat": "bg-no-repeat",
        repeat: "bg-repeat",
        "repeat-x": "bg-repeat-x",
        "repeat-y": "bg-repeat-y",
    },
};

export function normalizeClassTokenValue(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
        return value.flatMap(normalizeClassTokenValue);
    }

    if (typeof value === "string") {
        return value.split(/\s+/).filter(Boolean);
    }

    return [];
}

function getClassValue(propName, value) {
    return propClassValue[propName]?.[value] ?? value;
}

export function getClassTokensFromProps(props, classProps = []) {
    if (!props || typeof props !== "object") return [];
    return classProps.flatMap((key) => normalizeClassTokenValue(getClassValue(key, props[key])));
}

export function buildClassNameFromProps(props, classProps = []) {
    const baseTokens = getClassTokensFromProps(props, classProps);
    const responsive = props?.responsive && typeof props.responsive === "object" ? props.responsive : {};
    const responsiveTokens = Object.entries(responsive).flatMap(([breakpoint, breakpointProps]) => {
        const prefix = breakpointClassPrefix[breakpoint];

        if (!prefix || !breakpointProps || typeof breakpointProps !== "object") {
            return [];
        }

        return classProps.flatMap((key) => {
            if (!(key in breakpointProps) || !breakpointProps[key]) {
                return [];
            }

            return normalizeClassTokenValue(getClassValue(key, breakpointProps[key]))
                .filter((token) => !baseTokens.includes(token))
                .map((token) => `${prefix}:${token}`);
        });
    });

    return [...baseTokens, ...responsiveTokens];
}
